import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackModalOpen } from './tracking';
import { getOfferChatSrc } from './utils';
import { closeChat } from '../../actions/chat';
import { ChatModal } from '../../components/ChatModal';
import { ChatPopup } from '../../components/ChatPopup';
import { selectPage, selectTotalCount } from '../../selectors';
import { selectChat } from '../../selectors/chat/selectChat';
import { TContentType } from '../../types/content';

interface IChatContainerProps {
  type?: TContentType;
}

export const ChatContainer: React.FC<IChatContainerProps> = ({ type = 'full' }) => {
  const dispatch = useDispatch();

  const { isOpen, offer, position, defaultMessage } = useSelector(selectChat);
  const { deviceType } = useSelector(selectPage);
  const total = useSelector(selectTotalCount);

  React.useEffect(() => {
    if (isOpen && offer && total && position) {
      trackModalOpen({ offer, position, total, deviceType });
    }
  }, [isOpen, offer, position, total, deviceType]);

  const onClose = React.useCallback(() => dispatch(closeChat()), [dispatch]);

  if (!isOpen) {
    return null;
  }

  const src = getOfferChatSrc({ offer, defaultMessage });

  if (type === 'short') {
    return <ChatPopup src={src} onClose={onClose} />;
  }

  return <ChatModal src={src} isOpen={isOpen} onClose={onClose} />;
};
